import React, { useEffect, useState } from 'react';import { Routes, Route } from 'react-router-dom'
import type { Restaurant, RestaurantFormData} from './restaurant.types';
import RestaurantList from './Components/RestaurantList';
import RestaurantForm from './Components/RestaurantForm';
import { useNavigate } from 'react-router-dom';
import RestaurantEdit from './Components/EditRest';
import { FormErrorProvider } from './Context/FormErrorContext';
import {   getUserRestaurants, archiveRestaurant } from '../../lib/api/restaurant.apis';

archiveRestaurant

const Dashboard = () => {
    const [backendRestaurants, setBackendRestaurants] = useState<Restaurant[]>([]);
    const [selectedRestaurant, setSelectedRestaurant] = useState<Restaurant | null>(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    // load both local + backend (stubbed)
    useEffect(() => {
        setLoading(true)
        async function loadRestaurants() {
        try {
            const backendRestaurants = await getUserRestaurants();
            setBackendRestaurants(backendRestaurants);
        } catch (err) {
            console.error(err);
        } finally{
            setLoading(false);
        }
        }

        loadRestaurants();
    }, []);

    function restaurantToFormData(restaurant: Restaurant): Partial<RestaurantFormData> {
        return {
            name: restaurant.name,
            description: restaurant.description,
            location: restaurant.location,
            cuisine: restaurant.cuisine,
            typeOfFood: restaurant.typeOfFood,
            experience: restaurant.experience,
            tags: restaurant.tags,
            budgetLevel: restaurant.budgetLevel,
            specialFeatures: restaurant.specialFeatures,
            priceRange: { min: 0, max: 0 },
            openingHours: restaurant.openingHours,
            gallery: {
                // Use nulls or fake File references — you CANNOT recreate Files from URLs,
                // so you can only leave them empty or placeholders.
                cover: null,
                food: restaurant.gallery.food ?? [],
                ambiance: restaurant.gallery.ambiance ?? [],
                menu: restaurant.gallery.menu ?? [],
            },
        };
    }

    return (
        <Routes>
            <Route index element={
                <RestaurantList
                    restaurants={backendRestaurants}
                    onCreateRestaurant={() => {
                        setSelectedRestaurant(null);
                        navigate("/dashboard/create")
                    }}
                    loading={loading}
                />
            }/>

            <Route path={`edit/:restaurantId`} element={
            (
                <RestaurantEdit />
            )
            } />

            <Route path='create' element={
            <FormErrorProvider>
                <RestaurantForm
                    initialData={selectedRestaurant ? restaurantToFormData(selectedRestaurant) : undefined}
                />
            </FormErrorProvider>
            } />

        </Routes>
    )
}

export default Dashboard